module.exports = __webpack_public_path__ + "img/1.fc298a14.png";